enum UserType {
    ADMIN = "ADMIN",
    USER = "USER",
    ENTERPRISE_USER = "ENTERPRISE_USER",
    ENTERPRISE_MANAGER = "ENTERPRISE_MANAGER",
}

export const B2C_USER_TYPES: readonly UserType[] = [
    UserType.ADMIN,
    UserType.USER,
];

export const isB2CUserType = (userType?: UserType | string): boolean =>
    userType !== undefined && B2C_USER_TYPES.includes(userType as UserType);

export default UserType;
